// utils/cookieUtils.js

export function setCookie(name, value, days = 365) {
  if (import.meta.env.SSR) return
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`
}

export function getCookie(name, cookie) {
  const cookieSource = !import.meta.env.SSR ? document?.cookie : cookie ? cookie || "" : ""
  return (
    cookieSource
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1] ?? null
  )
}

export function deleteCookie(name) {
  if (import.meta.env.SSR) return
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
}
